export default __webpack_public_path__ + "static/logo-2-22718974a9f7945064added1bb104801.webp";